import { useQuery } from '@tanstack/react-query';
import { 
  getProject, 
  useGetProject,
  getProjectAvailableProjects,
  useGetProjectAvailableProjects
} from '../api/project-api/project-api';


export const useProjects = () => {
  return useGetProject({
    query: {
      staleTime: 1000 * 60 * 5,
      refetchOnWindowFocus: true,
      retry: 2,
    }
  });
};

export const useProjectCatalog = () => {
  return useGetProjectAvailableProjects({
    query: {
      staleTime: 1000 * 60 * 30,
      refetchOnWindowFocus: false,
    }
  });
};